import { Outlet, RouteObject } from "react-router-dom";
import ApprenticeshipFormsRoute from "./apprenticeship";

const FormsRoute: RouteObject = {
    path: "formulaires",
    element: <Outlet />,
    children: [ApprenticeshipFormsRoute]
};
export default FormsRoute;
